module.exports = __webpack_public_path__ + "static/edf-b0865e7f5da25b2525a96b0ccff548f2.png";